import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ApiResponseUserData,
  UserData,
} from '../../../shared/models/user-data.model';
import { AdminService } from '../../../shared/services/admin.service';
import {
  COMMON_IMPORTS,
  PIPES_IMPORTS,
} from '../../../shared/imports/common-imports';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [COMMON_IMPORTS, PIPES_IMPORTS, SpinnerComponent],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss',
})
export class UserListComponent {
  @Input() fetchUsers = new Observable<void>();
  @Output() isLoadingChange = new EventEmitter<boolean>();
  userData: UserData[] = [];
  private _isLoading = false;

  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
    this.isLoadingChange.emit(value);
  }

  constructor(private readonly _adminService: AdminService) {}
  ngOnInit() {
    this.loadUserList();

    this.fetchUsers.subscribe(() => {
      this.loadUserList();
    });
  }

  loadUserList() {
    this.isLoading = true;
    this._adminService
      .getUserList()
      .then((data: ApiResponseUserData) => {
        this.userData = data.users.map((user) => {
          return {
            ...user,
            markets: user.markets.map((mar) => mar.replace('_', ' ')),
            regions: user.regions.map((reg) => reg.replace('_', ' ')),
          };
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
